import httpApi from "@src/utils/httpApi";
import { CuratorConversationRealtimeConfig } from "@src/types/curatorConversationRealtime";

export const getCuratorConversationRealtimeConfig =
  async (): Promise<CuratorConversationRealtimeConfig | null> => {
    try {
      const response = await httpApi.get(
        "/api/curator-conversations/realtime-config"
      );
      return response.data?.data ?? null;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(
        "Error fetching curator conversation realtime config",
        error
      );
      return null;
    }
  };
